import {
	REACT_APP_API_HOST as API_HOST,
	REACT_APP_KYC_FRONTEND_DOMAIN,
} from 'envs';

// dev2 must be tested BEFORE the others and named explicitly: none of the
// patterns below matches https://api.dev2.simplici.io/v1 (`isProd`'s
// /api.simplici.io/ needs "api" + one char + "simplici", and dev2 has ".dev2."
// in between), so every link the panel built for dev2 -- the QR "Copy URL",
// the embed snippet, the session Re-invite -- fell through to the stage
// default and the whole applicant journey ran on secure.stage.satschel.com.
const isDev2 = /dev2/gi.test(API_HOST);
const isStage = /stage/gi.test(API_HOST);
const isPP = /pp/gi.test(API_HOST);
const isProd = /api.simplici.io/gi.test(API_HOST);
const isBeta = /beta/gi.test(API_HOST);

// The applicant host is configuration, not something to guess from the API
// host. REACT_APP_KYC_FRONTEND_DOMAIN is already what the sign-up iframe uses
// (components/kyc-web-components) and is set on every environment that has a
// non-derivable host -- localhost:<port> locally, dev2.simplici.io/kyc on dev2.
// The regex table stays only as the fallback for deployments that never set it.
const configuredHost = (REACT_APP_KYC_FRONTEND_DOMAIN ?? '').replace(/\/+$/, '');

const hostUrl = () => {
	if (configuredHost) return configuredHost;
	if (isDev2) return 'https://dev2.simplici.io/kyc';
	if (isStage) return 'https://secure.stage.satschel.com';
	if (isPP) return 'https://secure.pp.satschel.com';
	if (isProd) return 'https://secure.simplici.io';
	if (isBeta) return 'https://secure.beta.simplici.io';
	return 'https://secure.stage.satschel.com';
};

const hostUrlSandBox = () => {
	// Prod and beta point sandbox links at a DIFFERENT host on purpose, so the
	// configured domain must not override them there.
	if (isProd) return 'https://secure.beta.simplici.io';
	if (isBeta) return 'https://secure.pp.satschel.com';
	// Local and dev2 have no separate sandbox host; the sandbox link is the
	// same host with `allow=true`, exactly as stage already behaves.
	if (configuredHost) return configuredHost;
	if (isDev2) return 'https://dev2.simplici.io/kyc';
	return 'https://secure.stage.satschel.com';
};

export const KycMobileHostSandbox = hostUrlSandBox();
export const KycMobileHost = hostUrl();
export { isStage, isPP, isProd };
